import { useEffect, useMemo, useState } from "react";
import SelectedCaseChip from "./selected-cases-chip";

import {
  TextField,
  Stack,
  IconButton,
  Popover,
  Typography
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { useSelector } from "react-redux";
const SelectedCasesList = ({ staticSelectedRows, setStaticSelectedRows }) => {

  const { Languages, Districts } = useSelector(state => state.user || {});

  const [casesMap, setCasesMap] = useState(new Map(staticSelectedRows));
  const [popoverAnchor, setPopoverAnchor] = useState(null);
  const popoverOpen = Boolean(popoverAnchor);

  const handlePopoverOpen = (event) => {
    setPopoverAnchor(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setPopoverAnchor(null);
  };


  const filterSearch = (e) => {
    let value = e.target.value.toLowerCase();
    if (value.length === 0) {
      setCasesMap(new Map(staticSelectedRows));
      return;
    }

    // so now we have to check for the name with the values of the map
    let filtered = Array.from(casesMap.values()).filter((selectedCase) => {
      return selectedCase.name.toLowerCase().includes(value);
    });

    // go through the filtered array and add it to the casesMap
    let newMap = new Map();
    filtered.forEach((selectedCase) => {
      newMap.set(selectedCase["_id"], selectedCase);
    });
    setCasesMap(newMap);
  };

  const handleRemoveSelectedCase = (id) => {
    let newMap = new Map(staticSelectedRows);
    newMap.delete(id);
    setStaticSelectedRows(newMap);
    setCasesMap(newMap);
  };

  useEffect(() => {
    setCasesMap(new Map(staticSelectedRows));
  }, [staticSelectedRows]);

  const attemptMoreThanThreeCases = useMemo(() => {
    return Array.from(casesMap.values()).filter((selectedCase) => {
      return selectedCase.attempt > 2;
    });
  }, [casesMap])

  const normalCases = useMemo(() => {

    return Array.from(casesMap.values()).filter((selectedCase) => {
      return selectedCase.attempt <= 2;
    });

  }, [casesMap])

  return (
    <Stack direction={"column"} spacing={2}>
      <Stack direction="row" spacing={1} alignItems="center">
        <IconButton
          onClick={handlePopoverOpen}
          size="small"
          sx={{ color: 'text.secondary' }}
        >
          <InfoIcon fontSize="small" />
        </IconButton>
        <Popover
          open={popoverOpen}
          anchorEl={popoverAnchor}
          onClose={handlePopoverClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
        >
          <Typography sx={{ p: 2 }}>
            Cases with more than 3 attempts are highlighted with red borders.
          </Typography>
        </Popover>
      </Stack>
      <Stack direction={"row"} spacing={1} alignItems="center">

        <TextField
          label="Search"
          InputLabelProps={{
            shrink: true,
          }}
          onChange={(e) => {
            filterSearch(e);
          }}
        />
      </Stack>
      <Stack
        direction={"row"}
        spacing={2}
        sx={{
          // maxHeight: "200px",
          flexWrap: "wrap",
          overflowY: "auto",
          rowGap: "1em",
        }}
      >
        {attemptMoreThanThreeCases.map((selectedCase) => (
          <SelectedCaseChip
            key={selectedCase["_id"]}
            chipData={selectedCase}
            handleDelete={() => handleRemoveSelectedCase(selectedCase["_id"])}
          />
        ))}
        {normalCases.map((selectedCase) => (
          <SelectedCaseChip
            key={selectedCase["_id"]}
            chipData={selectedCase}
            handleDelete={() => handleRemoveSelectedCase(selectedCase["_id"])}
          />
        ))}

      </Stack>
    </Stack>
  );
};

export default SelectedCasesList;
